// extracted by mini-css-extract-plugin
export var container = "_f7-0";
export var infoIcon = "_f7-2";
export var internalLabel = "_f7-3";
export var titleRowCol = "_f7-1";